import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/basic-health/current-cardiological-state/ekg";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	ekg: {
		id: "form.ekg",
		defaultMessage: "EKG"
	},
	value: {
		id: "form.ekg.value",
		defaultMessage: "EKG történt?"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "bh_ekg",
	value: {
		schemaId: "ekg",
		title: messages.ekg,
		validator,
		fieldset,
		isImportant: true
	}
};
